import { FONT_SIZE_TOKENS } from '@flashka/shared/ui';

import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Teach tailwind-merge the design-system `text-{style}` size tokens
// (`text-h3`, `text-b3`, …) so they conflict as FONT-SIZE, not text-color.
// Without this, merging a typography token with a colour class silently
// drops one of them. Token list lives in @flashka/shared/ui (cn.ts).
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: FONT_SIZE_TOKENS }],
      // The dotted-paper background (tailwind.config `backgroundImage` /
      // `backgroundSize`). tailwind-merge doesn't know these custom keys, so
      // it files them under `bg-color` and collapses
      // `bg-background bg-dotted-pattern bg-dotted-size` down to the last
      // one — the panel silently loses its dots.
      'bg-image': [{ bg: ['dotted-pattern', 'dotted-pattern-dark'] }],
      'bg-size': [{ bg: ['dotted-size'] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
